<section class="ofw-page-container">
  <section class="main" fxLayout="column" fxLayoutGap="16px">
    <article class="initial-article" fxLayout="column">
      <div class="banner">
        <span class="top-banner-text">SEAMAN PERSONAL LOAN</span><br>
        <span class="lower-banner-text">MADE EASY</span><br>
      </div>
      <div class="adv-container">
        <span class="advantage">
          Fast, easy, and reliable seaman loan.<br>
          Borrow as much as 2x your salary.
        </span>
      </div>
      <div class="apply-now" fxFlexAlign="center" (click)="loanApplicationService.forward()">APPLY NOW!</div>
    </article>

    <bb-product-advantage></bb-product-advantage>

    <article class="sub-article">
      <h1 class="sub-article-title">
        The OFW Loan Designed for OFWs
      </h1>
      <p class="sub-article-content">
        Each day there are more OFWs being sent abroad compared to the number of Filipinos finding a job
        domestically. On aggregate the Philippines deployed a little over 1.7 million OFWs in 2014 versus 1.02
        million filipinos finding a local job. These OFWs contribute an estimate 10% of the country’s GDP. They
        are considered by many to be the modern day heroes of the country.<br><br>

        Balikbayad was designed to address the financing needs of OFWs. We understand that there are costs
        involved in securing an overseas job. We are here to help the ones who have secured a job abroad and
        needs financial assistance.
      </p>
    </article>

    <article class="sub-article">
      <h1 class="sub-article-title">How It Works:</h1>
      <bb-how-it-works-figures></bb-how-it-works-figures>
    </article>

    <article class="sub-article">
      <h1 class="sub-article-title">What We Can Offer</h1>
      <p class="sub-article-content">
       <b>Sea-Based OFW Loan</b> – A collateral-free online loan for seamen. Sea-based OFWs can now apply for
        a quick, easy, and hassle-free loan with minimal requirements through Balikbayad. We offer 100%
        payout on your approved loan amount – no deductions, additional fees, or hidden charges!
      </p>
    </article>

    <article class="sub-article">
      <h1 class="sub-article-title">Why Balikbayad?</h1>
      <p class="sub-article-content">
        Balikbayad adresses the most pressing issues OFWs face in applying for a loan. For this reason we:
      </p>
      <bb-why-balikbayad-figures></bb-why-balikbayad-figures>
    </article>

    <article class="sub-article">
      <h1 class="sub-article-title">Who Can Apply?</h1>
      <ul class="sub-article-content">
        <li>Seamen currently working abroad with an active employment contract.</li>
        <li>Balik Manggagawa, or seamen who previously worked abroad and planning to go back but have no
          specific funds.
        </li>
        <li>First time OFWs.</li>
      </ul>
    </article>

    <article class="sub-article">
      <h1 class="sub-article-title">Who Can Be A Co-Maker?</h1>
      <ul class="sub-article-content">
        <li>Spouse</li>
        <li>Parents</li>
        <li>Siblings</li>
        <li>Children of Legal Age</li>
        <li>Live in Partner (w/ child)</li>
      </ul>
    </article>

    <article class="sub-article">
      <h1 class="sub-article-title">What are the Requirements?</h1>
      <bb-requirements-figures [employmentType]="seaman"></bb-requirements-figures>
    </article>

    <article class="last-article" fxLayout="column">
      <div class="banner">
        <span class="top-banner-text">SEAMAN PERSONAL LOAN</span><br>
        <span class="lower-banner-text">MADE EASY</span><br>
      </div>
      <div>
    <span class="advantage">
      Fast, easy, and reliable seaman loan.<br>
      Borrow as much as 2x your salary.
    </span>
      </div>
      <div class="apply-now" fxFlexAlign="center" (click)="loanApplicationService.forward()">APPLY NOW!</div>
    </article>

  </section>
</section>
